import { withAuthenticationRequired } from "react-oidc-context";
import { Outlet } from "react-router";
import { SESSION_STORAGE_LOGIN_REDIRECT_URI } from "./CallbackRoute.tsx";

function ProtectedRoute() {
  return <Outlet />;
}

export default withAuthenticationRequired(ProtectedRoute, {
  onBeforeSignin: () => {
    sessionStorage.setItem(
      SESSION_STORAGE_LOGIN_REDIRECT_URI,
      window.location.pathname + window.location.search + window.location.hash,
    );
  },
});
